module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei5.svg";